export const ROUTES = {
  LOGIN: "/login",
  VERIFY: "/auth/verify",
  PAIR: "/pair/login",
  ENROLL: "/enroll",
  HOME: "/",
  ASSETS: "/app/assets",
  TRIPS: "/app/trips",
  ALERTS: "/app/alerts",
  SUPPORT: "/app/support",
  SYSTEM: "/app/system",
  STANDBY_SENSORS: "/app/system/standbySensors",
  READERS: "/app/system/readers",
  REPORTS: "/app/reports",
  TOWERS: "/app/towers",
  /** Admin-only; not linked from sidebar or mobile nav — open via URL only. */
  SENSOR_LOCATION_DASHBOARD: "/app/admin/sensor-location-dashboard",
};
